'use strict';

function ResponsiveVideo() {
  this.id = null;
  this.node = null;
  this.extends = [_ResponsiveLayout];
  this.smallSrc;
  this.mediumSrc;
  this.largeSrc;
  this.xlargeSrc;
  this.className;

  this.init = function () {
    // define a isPlaying property on all media elements
    if (typeof HTMLMediaElement.prototype.isPlaying === 'undefined') {
      Object.defineProperty(HTMLMediaElement.prototype, 'isPlaying', {
        get: function get() {
          var playing = false;
          try {
            playing = !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
          } catch (e) {
            /* avoids illegal invocation error */
          }
          return playing;
        }
      });
    }

    // build HTML for media player
    this._videoElement = document.createElement('video');
    this._videoElement.setAttribute('autoplay', 'true');
    this._videoElement.setAttribute('loop', 'true');
    this._videoElement.setAttribute('playsinline', 'true');
    this._videoElement.muted = true;
    if (this.className) this._videoElement.classList.add(this.className);
    this._sourceElement = document.createElement('source');
    this._sourceElement.setAttribute('type', 'video/mp4');
    this._pickResolutionSpecificSource();
    this._videoElement.appendChild(this._sourceElement);
    this.node.appendChild(this._videoElement);

    // update source if resolution changes
    this.registerResponsiveFunction(this._pickResolutionSpecificSource.bind(this), null, null);
  };

  this.initAllReady = function () {};

  this._pickResolutionSpecificSource = function () {
    var availableSources = [this.xlargeSrc, this.largeSrc, this.mediumSrc, this.smallSrc];
    var validSources = [];

    this.activeRange();
    if (this.xlargeRange) {
      validSources = availableSources;
    } else if (this.largeRange) {
      validSources = availableSources.slice(1);
    } else if (this.mediumRange) {
      validSources = availableSources.slice(2);
    } else {
      validSources = availableSources.slice(3);
    }
    this._setBestSource(validSources);
  };

  this._setBestSource = function (sources) {
    this._setSource(sources.find(function (element) {
      return element != null;
    }));
  };

  this._setSource = function (newSourceFile) {
    if (newSourceFile != this._sourceElement.getAttribute('src')) {
      var wasPlaying = false;
      if (this._videoElement.isPlaying) {
        this._videoElement.pause();
        wasPlaying = true;
      }
      this._sourceElement.setAttribute('src', newSourceFile);
      this._videoElement.load();
      if (wasPlaying) {
        this._videoElement.play();
      }
    }
  };

  this.destroy = function () {
    this.deregisterResponsiveFunctions();
  };
}